export const LOGO_MONACO = '/logo.png';
export const HOTEL_ICON = '/hotel-icon.png';
